
import { Component, Vue } from 'vue-property-decorator'
import BeaconList from '@/components/beacon/BeaconList.vue'

@Component({
  name: 'Beacons',
  components: { BeaconList }
})
class Beacons extends Vue {}

export default Beacons
